/**
 * Password validator for login pages
 */
import { NumbColorFunc, StringBoolFunc, StringNumFunc } from 'types/password';

// has number
const hasNumber: StringBoolFunc = (number) => new RegExp(/[0-9]/).test(number);

// has mix of small and capitals
const hasMixed: StringBoolFunc = (number) => new RegExp(/[a-z]/).test(number) && new RegExp(/[A-Z]/).test(number);

// has special chars
const hasSpecial: StringBoolFunc = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

// label and strength-bar background class for a password strength
export const strengthColor: NumbColorFunc = (count) => {
    if (count < 2) return { label: 'Poor', color: 'bg-error' };
    if (count < 3) return { label: 'Weak', color: 'bg-warning' };
    if (count < 4) return { label: 'Normal', color: 'bg-warning-dark' };
    if (count < 5) return { label: 'Good', color: 'bg-success' };
    if (count < 6) return { label: 'Strong', color: 'bg-success-dark' };
    return { label: 'Poor', color: 'bg-error' };
};

// password strength indicator
export const strengthIndicator: StringNumFunc = (number) => {
    let strengths = 0;
    if (number.length > 5) strengths += 1;
    if (number.length > 7) strengths += 1;
    if (hasNumber(number)) strengths += 1;
    if (hasSpecial(number)) strengths += 1;
    if (hasMixed(number)) strengths += 1;
    return strengths;
};
